///<reference path="scopeEditorController.ts"/>
///<reference path="processEditor-module.ts"/>

interface INotifications {
    notify(msg: string);
    error(msg: string);
}

interface ITagService {
    getTagsArray(tagString: string): string[];
}

module ProcessEditor {
    'use strict';
    import IModalService = angular.ui.bootstrap.IModalService;

    export class ProcessEditorController {

        public process: Process;
        public showProcessNameEditor: Boolean;
        public tags: Tag[];
        public usedTags;
        public processSaveRequest;
        public processDirty: Boolean;
        public allNodesConnected: Boolean;
        public allPathsReturn: Boolean;

        static $inject = ["$location", "$routeParams", "$window", "ProcessService", "notifications", "$rootScope", "$scope", "TagService", "GraphValidationService", "graphEditDisabled","$uibModal"];
        public constructor(private $location: ng.ILocationService, $routeParams: IProcessEditorRouteParams,
            private $window: ng.IWindowService, private processService: ProcessService,
            private notifications: INotifications, private $rootScope: ng.IRootScopeService,
            private $scope: IProcessEditorScope, private tagService: ITagService,
            private graphValidationService: GraphValidationService, public graphEditDisabled = false,
            private $modal: IModalService) {

            $rootScope.$on("process.dirty.frends", () => {
                this.processDirty = true;
            });

            $rootScope.$broadcast("loadingspinner.manual.spin");
            this.processSaveRequest = false;
            this.allNodesConnected = true;
            this.allPathsReturn = true;
            this.processDirty = false;

            var processPromise;
            if ($routeParams.id) {
                // id set -> edit
                processPromise = processService.getData($routeParams.id);
            } else {
                this.showProcessNameEditor = true; // show the editors by default
                processPromise = processService.getData(null);
            }

            processPromise
                .then((process: Process) => {
                    this.process = process;
                    this.setPageTitle();
                    var tagsArray: string[] = tagService.getTagsArray(process.tagString);
                    this.tags = _.map(tagsArray, (tag) => { return new Tag(tag); });
                }, (error) => {
                    console.error("Error when fetching data", error);
                })
                .finally(() => {
                    $rootScope.$broadcast('loadingspinner.manual.stop');
                });

            processService.getUsedTags().then((response) => {
                if (response.data) {
                    this.usedTags = response.data;
                }
            });
        }

        private setPageTitle() {
            if (this.process.id) {
                this.$window.document.title = FRENDS.Localizations.Process + " " + this.process.name + " - " + this.process.majorVersion + "." + this.process.minorVersion + "." + this.process.version;
            }
        }

        public getAvailableTags(inputString) {
            return _.filter(this.usedTags, (tag: string) => { return tag.indexOf(inputString) !== -1; });
        }

        public checkDirty() {
            return this.processDirty;
        }

        public save(processEditorForm:ng.IFormController, saveAsVersion: boolean) {
            this.$rootScope.$broadcast('validate.trigger.frends');
            var validation = this.graphValidationService.validateGraph();

            if (validation.success) {
                if (processEditorForm.$invalid) {
                    this.$scope.showValidationErrors = true;
                    this.notifications.error(FRENDS.Localizations.Validation_InvalidProcessEditorForm);
                    return;
                }
                if (saveAsVersion) {
                    this.openVersionModal(this.process, processEditorForm);
                } else {
                    this.processSave(processEditorForm);
                }
            } else {
                this.notifications.error(validation.errorMessage);
            }
        }

        private processSave(processEditorForm: ng.IFormController) {
            this.processSaveRequest = true;
            this.process.tagString = _.map(this.tags, (t: Tag) => { return t.text }).join();
            this.processService.save(this.process).then((response: Frends.IJsonResponse) => {
                this.processSaveRequest = false;
                if (response && response.success) {
                    // Saved successfully, set the form clean so it doesnt ask if we are sure about the redirect
                    this.processDirty = false;
                    processEditorForm.$setPristine();
                    this.$rootScope.$broadcast("reset.dirty.frends");

                    // go to the latest element list
                    var absUrl = this.$location
                        .path("/Process/List/" + ProcessList.DEFAULT_ENV_NAME)
                        .search("highlightProcess", response.data)
                        .absUrl();
                    this.$window.location.href = absUrl;
                } else {
                    if (response && response.data) {
                        console.log("Compilation errors: ", response.data.errors, response.data.sourceCode);
                    }
                }
            });
        }

        public openVersionModal(process: Process, processEditorForm: ng.IFormController ) {
            var options: ng.ui.bootstrap.IModalSettings = {
                templateUrl: "saveAsVersionModal.htm",
                windowClass: "default-modal-styles",
                backdrop: "static",
                resolve: {
                    majorVersion: () => process.majorVersion,
                    minorVersion: () => process.minorVersion,
                    version: () => process.version,
                    majorMinorVersions: () => process.majorMinorVersions
                },
                controller: "SaveAsVersionModalController as ctrl"
            };
            this.$modal.open(options).result.then((result: IMajorMinorVersions) => {
                this.process.majorVersion = result.majorVersion;
                this.process.minorVersion = result.minorVersion;
                this.processSave(processEditorForm);
            });
        };
    }
 
    app.controller("ProcessEditorController", ProcessEditorController);

    export interface IProcessEditorRouteParams {
        id?: number|string;
    }

    export interface IProcessEditorScope extends ng.IScope{
        processEditorForm: ng.IFormController;
        showValidationErrors: boolean;
    }
}